<template>
    <div class="new-bank">
        <modal class="new-bank-modal" :display="newBank"  @modalStatus="closeModal('newBank')" >
            <h1>新增銀行卡</h1>
            <div v-if="errorMsg" class="alarm-msg">
                {{errorMsg}}
            </div>
            <div class="content">
                <div class="bank">
                    <span>選擇銀行</span>
                    <rent-select class="select-scroll" refName="bank" selectMsg="請選擇銀行" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li :data-id="bank.bankCode"  v-for="(bank, index) in bankList" :key="index">
                                {{bank.bankCode}} {{bank.bankName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="bank-branch">
                    <span>分行名稱</span>
                    <rent-select class="select-scroll" refName="bankBranch" :selectMsg="bankBranchDefault.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="bankBranchDefault.state">
                        <ul>
                            <li :data-id="bankBranch.branchCode"  v-for="(bankBranch, index) in bankBranchList" :key="index">
                                {{bankBranch.bankName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="bank-account">
                    <span>銀行帳號</span>
                    <input v-model="bankCard.account" type="text">
                </div>
                <div class="name">
                    <span>銀行戶名</span>
                    <input v-model="bankCard.name" type="text">
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="saveBankCard" :disabled="disabledState">審核</button>
                <button class="border-button" @click="closeModal('newBank')">取消</button>
            </div>
        </modal>
        <div class="no-result" v-if="filterByState.length == 0 && bankCardState != null">
            0 個篩選結果
            <button class="default-button" @click="clearFilter()">清除篩選</button>
        </div> 
        <ul>
            <li class="card" v-for="(card,index) in filterByState" :key="index">
                <div class="title">
                    <img :src="'../../../../../static/img/bank/'+card.bankCode+'.png'" alt="">
                    {{card.bankName}}
                </div>
                <div class="account">
                    {{bankAccountEncrypt(card.bankAccountNo)}}
                </div>
                <div class="card-tool-bar">
                    <default-radio @click.native="setDefaultBankCard(card.cid)" v-if="card.status == 'NORMAL'" ref="tanantConfirm" v-model="defaultCard" :isPropChecked="card.default? true:false" :value="defaultCard" :val="index" checkboxMsg="預設" tickColor="white" bgColor="#fff" borderColor="#a8a5a4" :setDefault="isDefault"></default-radio>
                    <span class="not-allow" v-if="card.status == 'REJECT'">查看未通過原因</span>
                    <dot-dropmenu v-if="card.status == 'NORMAL' && bizAuth.deleteBankCard.hasRight || card.status == 'REJECT' && bizAuth.deleteBankCard.hasRight">
                        <ul >
                            <li v-if="card.status == 'REJECT'">編輯</li>
                            <li v-if="bizAuth.deleteBankCard.hasRight" @click="deleteBankCard(card.cid)">刪除</li>
                        </ul>
                    </dot-dropmenu>
                </div>
                <div class="state blue" v-if="card.status == 'NORMAL'">
                    審核通過
                </div>
                <div class="state red" v-if="card.status == 'REJECT'">
                    審核失敗
                </div>
                <div class="state gray" v-if="card.status == 'UNDER_REVIE'">
                    審核中
                </div>
            </li>
            <li v-if="bizAuth.createBankCard.hasRight && bankCardState == null" class="add" @click="newBankEvent()">
                <img src="@/assets/img/icon/plus_pink.svg" alt="">
                新增銀行卡
            </li>
        </ul>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import DefaultRadio from '@/components/widge/DefaultRadio.vue';
import { mapGetters } from 'vuex'

import { 
    apiGetBankList,
    apiGetBankBranchList,
    apiBizSaveBankCard,
    apiBizSetDefaultBankCard,
    apiBizDeleteBankCard
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            bankBranchDefault: {
                state: false,
                msg: '請選擇分行'
            },
            // bankCardList: [],
            bankCard:{
                bank: null,
                bankBranch: null,
                account: null,
                name: null
            },
            defaultCard: null,
            newBank: false,
            isDefault: false,
            errorMsg: null,
            disabledState: true,
            bankList: [],
            bankBranchList: []
        }
    },
    props:{
        bankCardState: null,
    },
    mounted() {
        this.getBankList()
        this.getBankCardList()
    },
    watch: {
        bankCard: {
            handler: function (val){
                if(val.bank){
                    this.getBankBranchList(val.bank)
                }

                if(val.bank && val.bankBranch && val.account && val.name){
                    this.disabledState = false
                }else{
                    this.disabledState = true
                }

            },
            deep: true
        }
    },
    methods: {
        getSelectId: function (value) {
            let targetId = event.target.dataset.id
            this.isDefault = false
            if( value.ref == 'bank' ){
                this.bankCard.bank = targetId
                this.bankBranchDefault.state = true
            }else if( value.ref == 'bankBranch' ){
                this.bankBranchDefault.state = false
                this.bankCard.bankBranch = targetId
            }
        },
        getBankList: function () {
            apiGetBankList()
            .then(res =>{
                // console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.bankList = res.data.result.masterBankList
                }else{
                    this.errorMsg = res.data.errorMsg
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        getBankBranchList: function (bankId) {
            apiGetBankBranchList(bankId)
            .then(res =>{
                if(res.data.status = 'SUCCESS'){
                    this.bankBranchList = res.data.result.branchBankList
                }else{
                    this.errorMsg = res.data.errorMsg
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        getBankCardList: function () {
            this.$store.dispatch('getBankCardList')
            // apiGetBankCard()
            // .then(res => {
            //     // console.log(res)
            //     if(res.data.status == "SUCCESS"){
            //         this.bankCardList = res.data.result.bankInfoList
            //     }
            // })
            // .catch(err =>{
            //     console.log(err)
            // })
        },
        saveBankCard: function () {
            this.$analyticsBiz.logEvent('送出新增銀行卡', { screen_name: '送出新增銀行卡'})
            let data = this.bankCard
            apiBizSaveBankCard(data)
            .then(res => {
                console.log(res)
                if(res.data.result.errorResult == "NO_ERROR"){
                    this.closeModal('newBank')
                    this.getBankCardList()
                    //  console.log(res)
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        setDefaultBankCard: function (cid) {
            let data = {
                bankAccountCid: cid
            }

            apiBizSetDefaultBankCard(data)
            .then(res => {
                // console.log(res)
                if(res.data.status == 'SUCCESS'){
                    // this.getBankCardList()
                    this.$store.dispatch('getBankCardList')
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        deleteBankCard: function (cid) {
            let data = {
                bankAccountCid: cid
            }
            apiBizDeleteBankCard(data)
            .then(res => {
                // console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.getBankCardList()
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        // getBankIcon: function (val) {
        //     let url = '@/assets/img/bank/'+val+'.png'
        //     // console.log(url)
        //     return require(url)
        // },
        newBankEvent: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.newBank = true
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        closeModal: function (type) {
            if( type == 'newBank' ){
                this.bankCard = {
                    bank: null,
                    bankBranch: null,
                    account: null,
                    name: null
                }
                this.newBank = false
            }
        },
        bankAccountEncrypt: function (account) {
            return '*****'+account.substr(5)
        },
        clearFilter: function () {
            this.$emit('clearFilterEvent')
        }
    },
    computed: {
        bankCardDefault: function () {
            return this.bankCardList.filter((bankCard, index) => {
                if(bankCard.default){
                    this.defaultCard = index
                }
                return bankCard
            });
        },
        filterByState: function () {
            return this.bankCardDefault.filter((bankCard) => {
                if( this.bankCardState ){
                    console.log(bankCard.status)
                    console.log(this.bankCardState)
                    if( bankCard.status == this.bankCardState ){
                        return bankCard
                    }
                }else{
                    return bankCard
                }
            });
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            bankCardList: 'GET_BIZ_BANK_CARD_LIST',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        Modal,
        RentSelect,
        DefaultRadio,
        'dot-dropmenu': DotDropMenu,
    }
}
</script>
<style lang="scss">
    .new-bank{
        .new-bank-modal{
            .modal-content{
                width: 448px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin: 0 auto;
                        margin-top: 36px;
                        margin-bottom: 24px;
                    }
                    .alarm-msg{
                        padding: 8px 32px;
                        margin-bottom: 30px;
                        font-size: 16px;
                        font-weight: 500;
                        color: #fc7171;
                        background-color: rgba(240, 90, 62, 0.1);
                        line-height: 1.7;
                    }
                    .content{
                        padding: 0 32px 10px 32px;
                        // margin-bottom: 52px;
                        >div{
                            margin-bottom: 30px;
                            >span{
                                display: block;
                                margin-bottom: 12px;
                            }
                            input{
                                width: 100%;
                            }
                        }
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
        .no-result{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
            .default-button{
                width: 120px;
                margin-top: 16px;
            }
        }
        >ul{
            display: flex;
            flex-wrap: wrap;
            >li{
                position: relative;
                width: 255px;
                height: 172px;
                margin-right: 23px;
                margin-bottom: 23px;
                border-radius: 10px;
            }
            >li:nth-child(4n){
                margin-right: 0px;
            }
            .add{
                display: flex;
                justify-content: center;
                align-items: center;
                border: dashed 1px #ff9275;
                background-color: rgba(255, 146, 117, 0.1);
                box-sizing: border-box;
                cursor: pointer;
                color: #ff9275;
            }
            .card{
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                background-color: #ffffff;
                .title{
                    display: flex;
                    align-items: center;
                    padding: 20px 20px 18px 20px;
                    font-size: 16px;
                    font-weight: 500;
                    >img{
                        width: 30px;
                        height: 30px;
                        margin-right: 8px;
                    }
                }
                .account{
                    height: 20px;
                    color: #a8a5a4;
                    padding: 0 20px;
                }
                .card-tool-bar{
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 19px 20px;
                    .not-allow{
                        text-decoration: underline;
                    }
                    .dot-drop-menu{
                        position: absolute;
                        right: 20px;
                    }
                }
                .state{
                    position: absolute;
                    width: 100%;
                    height: 36px;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 500;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;
                }
                .state.blue{
                    color: #71aae5;
                    background-color: rgba(113, 170, 229, 0.1);
                }
                .state.red{
                    color: #fc7171;
                    background-color: rgba(255, 146, 117, 0.1);
                }
                .state.gray{
                    color: #a8a5a4;
                    background-color: #f6f6f6;
                }
            }
           
        }
    }
    // @media screen and (max-width: 1280px) {
    //     .new-bank{
    //         >ul{
    //             >li{
    //                 margin-right: 20px;
    //                 margin-bottom: 20px;
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/wallet/reciveAccount/newBank.vue